module.exports = __webpack_public_path__ + "img/tree.56f71b8.svg";